/**
 * @author Ivan Toth.
 */
var UserProfileController = (function () {
    function UserProfileController(settings, env, admin, $scope, $q, $timeout, socket, DTS) {
        this.settings = settings;
        this.env = env;
        this.admin = admin;
        this.$scope = $scope;
        this.$q = $q;
        this.$timeout = $timeout;
        this.socket = socket;
        this.DTS = DTS;
        this.toggle = { cty: false, prg: false, pref: true, rep: false };
        this.editing = { preferences: {} };
        this.df = {
            medium: { v: 'medium', f: 'MMM d, y h:mm:ss a', e: 'Jan 5, 2016 9:05:05 AM' },
            shortDate: { v: 'shortDate', f: 'M/d/yy', e: '1/5/16' },
            custom1: { v: 'custom1', f: 'dd/MM/yyyy', e: '01/05/2016' },
            custom2: { v: 'custom2', f: 'MM/dd/yyyy', e: '05/01/2016' }
        };
        this.events = { beingSaved: false };
        this.serverError = null;
    }
    UserProfileController.prototype.getAvatar = function () {
        return this.DTS.getAvatar(this.settings.up.email, 115);
    };
    UserProfileController.prototype.$onInit = function () {
        angular.copy(this.settings.up.preferences, this.editing.preferences);
        this.editing._id = this.settings.up._id;
    };
    /**
     * save - Function triggered when user clicks the Save button.
     *
     * @param  {type} event: any Browser event for the benefit of the display prompts (if needed)
     */
    UserProfileController.prototype.save = function (event) {
        var _this = this;
        this.events.beingSaved = true; //set flag to disable save button
        this.serverError = null;
        var saveBundle = { data: this.editing, changelog: null };
        //Make the call via a promise which will wait up to 30 seconds for a response
        this.savePromise(saveBundle).then(function (data) {
            //If response from server received
            _this.events.beingSaved = false; //enable save again
            if (data.error) {
                _this.serverError = data.error;
            }
            else {
                //this.admin.navigate('admin.users-view');
                //update the object in settings which will now be out of date...could reload, I spose...
                angular.copy(_this.editing.preferences, _this.settings.up.preferences);
            }
        }, function (nothingReturnedInTime) {
            //If no response from server received
            _this.events.beingSaved = false; //enable save again
            _this.serverError = 'The server does not appear to be responding, or did not respond in a reasonable time.';
        });
    };
    UserProfileController.prototype.savePromise = function (saveBundle) {
        var _this = this;
        this.deferred = this.$q.defer(); //Set deferred object...to be sent to browser
        this.$timeout(function () {
            _this.deferred.reject([]); //If not resolved within 3 seconds...reject
        }, 30000); //30 secs
        this.admin.updateUserProfile(saveBundle);
        // TO DO
        this.socket.forward('config.user_update', this.$scope);
        this.$scope.$on('socket:config.user_update', function (event, data) {
            _this.deferred.resolve(data); //add the results to the deferred object
        });
        return this.deferred.promise; //fire off the promise
    };
    UserProfileController.$inject = ['settings', 'env', 'admin', '$scope', '$q', '$timeout', 'socket', 'DTS'];
    return UserProfileController;
}());
var UserProfileComponent = (function () {
    function UserProfileComponent() {
        this.templateUrl = 'userprofile.html';
        this.controllerAs = 'vm';
        this.controller = UserProfileController;
    }
    return UserProfileComponent;
}());
angular
    .module('application')
    .component('userProfileSection', new UserProfileComponent());

//# sourceMappingURL=userprofile.component.js.map
